import * as React from "react";
import { Editor as DraftEditor, EditorState, ContentBlock } from "draft-js";

import * as css from "glamor";
import { TextArea } from "semantic-ui-react";

css.insertGlobal(".public-DraftEditorPlaceholder-root", {
	color: "grey",
	textAlign: "center"
});

interface IProps {
	editorState: EditorState;
	onEditorChange: (editor: EditorState) => void;
}
interface IState {}

class Editor extends React.Component<IProps, IState> {
	state = {};
	draftJS: any;

	onEditorChange = newState => this.setState({ editorState: newState });

	blockStyleFn = (block: ContentBlock) => {};

	render() {
		return (
			<div
				style={{
					padding: 12,
					border: "1px solid grey",
					minHeight: 300
				}}
				onClick={() => this.draftJS.focus()}
			>
				<TextArea
					as={() => (
						<DraftEditor
							placeholder="Click here to start filling out the information"
							ref={ref => (this.draftJS = ref)}
							editorState={this.props.editorState}
							onChange={this.props.onEditorChange}
							// style={{min}}
						/>
					)}
				/>
			</div>
		);
	}
}

export default Editor;



// WEBPACK FOOTER //
// ./src/components/Editor/Editor.tsx